import React from 'react';
import { ArrowRight } from 'lucide-react';
import { BusinessHero } from '@/components/ui/content-blocks';

const EcommerceHero = () => {
  return (
    <BusinessHero
      title="Zukunftssichere E-Commerce Plattformen"
      titleHighlight="E-Commerce Plattformen"
      description="Wir entwickeln maßgeschneiderte B2B & B2C Shop-Lösungen, die Conversion, Umsatz und Kundenerlebnis revolutionieren."
      details="Datengetrieben, KI-optimiert und perfekt auf deine Geschäftsprozesse abgestimmt – unsere E-Commerce Plattformen wachsen mit deinem Unternehmen und setzen neue Maßstäbe für digitalen Handel."
      backgroundStyle="silver"
      badges={[
        { text: "B2B Commerce", position: "top-left" },
        { text: "B2C Shop", position: "bottom-right" },
        { text: "Omnichannel", position: "top-right" }
      ]}
      primaryCTA={{
        label: "Lösungen entdecken",
        href: "#ecommerce-solutions"
      }}
      secondaryCTA={{
        label: "Strategie-Gespräch vereinbaren",
        href: "#contact",
        icon: <ArrowRight size={16} />
      }}
    />
  );
};

export default EcommerceHero; 